export const isFullStatic = false
export const staticPath = "/app/apps/admin/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"